module.exports = __webpack_public_path__ + "img/bn29.97f5d656.png";